import './CustomerAccountList.scss';

import React from 'react';

import EditViewRelationshipsAccountList from '../EditViewRelationshipsAccountList/EditViewRelationshipsAccountList';
import ReadOnlyRelationshipAccountList from '../ReadOnlyRelationshipAccountList/ReadOnlyRelationshipAccountList';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';


const CustomerNameWithPermissions = WithUserPermissions(({ customerName }) => (
  <span className="header-text">{customerName}</span>
));

const CustomerAccountList = ({
  accounts,
  customer,
  clearActiveCustomer,
  deleteCustomer,
  isActive,
  hasActive,
  setActiveCustomer
}) => {
  return (
    <section className="customer-account-list">
      <header className="customer-section-header">
        <CustomerNameWithPermissions
          customerName={customer.fullName}
          shouldMask
        />
        <span className="action-button-container">
          <button
            className="link-styled"
            id={`delete-customer-${customer.fullName.replace(/ /g, '_')}`}
            disabled={hasActive && !isActive}
            onClick={() => deleteCustomer(customer.fullName)}>
            Delete User
          </button>
          <button
            className="link-styled"
            data-testid="edit-button"
            disabled={hasActive && !isActive}
            id={`edit-customer-${customer.fullName.replace(/ /g, '_')}`}
            onClick={setActiveCustomer}>
            Edit
          </button>
        </span>
      </header>
      {isActive ? (
        <EditViewRelationshipsAccountList
          accountGroups={accounts}
          clearActiveCustomer={clearActiveCustomer}
          customerName={customer.fullName}
          grantee={customer}
        />
      ) : (
        <ReadOnlyRelationshipAccountList
          accountGroups={accounts}
          customerName={customer.fullName}
        />
      )}
    </section>
  );
};

export default CustomerAccountList;
